import { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { colTypesWidths } from '~/components/ui/tables/ag/columnTypes';
import { agTheme } from '~/components/ui/tables/ag/agTheme';
import {
  colDefsFundValuationEventTable,
  FundValuationEvent,
} from './colDefsFundValuationEventTable';

export type FundValuationEventTableProps = {
  loading: boolean;
  rowData: FundValuationEvent[];
};

export const FundValuationEventTable = ({
  loading,
  rowData,
}: FundValuationEventTableProps) => {
  const gridRef = useRef<AgGridReact<FundValuationEvent>>(null);
  return (
    <div style={{ height: '100%' }}>
      <AgGridReact
        rowData={rowData}
        ref={gridRef}
        loading={loading}
        columnDefs={colDefsFundValuationEventTable}
        columnTypes={colTypesWidths}
        tooltipShowDelay={0}
        theme={agTheme}
        suppressContextMenu
        colResizeDefault="shift"
        suppressCellFocus
        onColumnResized={(params) => {
          if (params.finished) params.api.sizeColumnsToFit();
        }}
        autoSizeStrategy={{
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        }}
      />
    </div>
  );
};
